<template>
  <van-popup
    position="bottom"
    class="preview-popup"
    v-model="isShowDetail"
    :closeable="false"
    @close="onCloseDetail"
    get-container="body"
  >
    <div class="preview-header">
      {{ name }}
      <img
        class="close-btn"
        src="https://editor.xesimg.com/tailor/resource/close-1761039658781.png"
        @click="onCloseDetail"
      />
    </div>
    <div class="preview-body">
      <main class="preview-scroll">
        <iframe
          class="detail_iframe"
          ref="detailIframe"
          sandbox="allow-scripts allow-same-origin"
          :src="previewUrl"
        ></iframe>
      </main>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    previewUrl: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowDetail: false,
    };
  },
  methods: {
    onCloseDetail() {
      this.isShowDetail = false;
    },
    openDetail() {
      this.isShowDetail = true;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";

.preview-header {
  .ellipsis-one;
  position: relative;
  height: 52px;
  padding: 0 40px;
  line-height: 52px;
  color: #333;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 17px;
  font-weight: 500;

  .close-btn {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 18px;
    right: 18px;
  }
}

.preview-popup {
  border-radius: 16px 16px 0 0;
  height: 80vh;
  overflow: hidden;

  .preview-body {
    font-size: 12px;
    height: calc(100% - 52px);
    display: flex;
    flex-flow: column;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    // header {
    //   padding: 16px;
    //   font-size: 18px;
    //   line-height: 20px;
    //   font-weight: 500;
    //   color: #333;
    //   text-align: center;
    // }
    .preview-scroll {
      flex-grow: 1;
      overflow-y: auto;
    }
  }

  .detail_iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
